export const dummy_popover_list_data = [
    { id: "item 1", hasError: true },
    { id: "item 2", hasError: false },
    { id: "item 3", hasError: true },
    { id: "item 4", hasError: true },
    { id: "item 5", hasError: false },
    { id: "item 6", hasError: true },
    { id: "item 7", hasError: true }]

export const mock_addresses = [
    {
        id: 1,
        fullAddress: "1888 Savannah Place Southeast, Washington, DC 20020-2104, USA",
        isPrimary: true,
        addressType: "office",
        riskLevel: "moderate",
        isResidential: true,
        isActive: true
    },
    {
        id: 2,
        fullAddress: "2455 Corporate Circle, Henderson, NV 89074-5687, USA",
        isPrimary: false,
        addressType: "office",
        riskLevel: "low",
        isResidential: false,
        isActive: true
    },
    {
        id: 3,
        fullAddress: "789 Business Park Drive, Austin, TX 78701-1234, USA",
        isPrimary: false,
        addressType: "office",
        riskLevel: "high",
        isResidential: true,
        isActive: false
    }
];

export const business_profile_tabs = [
    { id: "overview-tab-profile", label: "Overview", numberPlaceholder: "0", iconPlaceholder: "alert" },
    { id: "associated-tab-profile", label: "Associated people", numberPlaceholder: "3", iconPlaceholder: "alert" },
    { id: "addresses-tab-profile", label: "Addresses", numberPlaceholder: "2", iconPlaceholder: "checkmark" },
    { id: "main-website-tab-profile", label: "Official website", numberPlaceholder: "1", iconPlaceholder: "checkmark" },
    { id: "web-presence-tab-profile", label: "Web presence", numberPlaceholder: "4", iconPlaceholder: "checkmark" },
    { id: "liens-tab-profile", label: "Liens", numberPlaceholder: "0", iconPlaceholder: "alert" },
    { id: "litigations-tab-profile", label: "Litigations", numberPlaceholder: "0", iconPlaceholder: "alert" },
    { id: "email-tab-profile", label: "Email", numberPlaceholder: "4", iconPlaceholder: "alert" },
    { id: "phone-tab-profile", label: "Phone number", numberPlaceholder: "3", iconPlaceholder: "checkmark" }
]

export const mock_business_profile_data = [
    {
        id: "FL",
        businessName: "Vintage Clothing Ecomm",
        status: "Active",
        stateId: "EXTUID_2903639",
        registeredAgent: "Callie Tyler",
        incorporationDate: "01/07/2010",
        url: "https://vintageclothing.com",
        ein: "47-1234567",
        dba: "Vintage Clothing Ecomm",
        primaryAddress: "1888 Savannah Place Southeast, Miami, FL 33101-2104, USA",
        email: "vintageclothing@contact.com",
        phone: "(305) 555-0198",
        website: "vintageclothing.com",
        selectedState: "FL"
    },
    {
        id: "GA",
        businessName: "Southern Tech Solutions",
        status: "Active",
        stateId: "EXTUID_4567890",
        registeredAgent: "Marcus Johnson",
        incorporationDate: "03/15/2015",
        url: "https://vintageclothing.com",
        ein: "58-9876543",
        dba: "Southern Tech Solutions",
        primaryAddress: "450 Peachtree Street NE, Atlanta, GA 30309-3214, USA",
        email: "info@southerntech.com",
        phone: "(404) 555-0276",
        website: "southerntech.com",
        selectedState: "GA"
    },
    {
        id: "AL",
        businessName: "Alabama Manufacturing Co",
        status: "Active",
        stateId: "EXTUID_7891234",
        registeredAgent: "Sarah Williams",
        incorporationDate: "09/22/2012",
        url: "https://vintageclothing.com",
        ein: "63-5432109",
        dba: "Alabama Manufacturing Co",
        primaryAddress: "1200 20th Street South, Birmingham, AL 35205-1876, USA",
        email: "contact@alamfg.com",
        phone: "(205) 555-0387",
        website: "alamfg.com",
        selectedState: "AL"
    },
    {
        id: "FD",
        businessName: "Federal District Consulting",
        status: "Active",
        stateId: "EXTUID_5678901",
        registeredAgent: "David Chen",
        incorporationDate: "11/08/2018",
        url: "https://vintageclothing.com",
        ein: "72-8765432",
        dba: "Federal District Consulting",
        primaryAddress: "1600 Pennsylvania Avenue NW, Washington, DC 20500-0001, USA",
        email: "admin@fdconsulting.com",
        phone: "(202) 555-0451",
        website: "fdconsulting.com",
        selectedState: "FD"
    },
    {
        id: "RG",
        businessName: "Regional Growth Partners",
        status: "Active",
        stateId: "EXTUID_3456789",
        registeredAgent: "Jennifer Rodriguez",
        incorporationDate: "06/30/2020",
        url: "https://vintageclothing.com",
        ein: "81-2109876",
        dba: "Regional Growth Partners",
        primaryAddress: "2500 Main Street, Suite 400, Richmond, VA 23220-3456, USA",
        email: "partners@rgrowth.com",
        phone: "(804) 555-0523",
        website: "rgrowth.com",
        selectedState: "RG"
    }
];

export const mock_verifications = {
    "total": 4,
    "verifications": [
        {
            "business_name": "Have to Clean Inc",
            "id": "92f26f4f-28b8-4e09-823a-280793c02c8e",
            "risk_score": 0.8223655856577509,
            "status": "completed",
            "created_at": "2025-06-20T04:26:05.908672+00:00"
        },
        {
            "business_name": "Meowden Co",
            "id": "9615d3e8-90a8-49af-a8e6-9acea632574b",
            "risk_score": 3.9084095127167973,
            "status": "completed",
            "created_at": "2025-06-20T04:26:14.081219+00:00"
        },
        {
            "business_name": "Renew Restore LLC",
            "id": "a1072499-c352-45f8-a3e7-206284128dbb",
            "risk_score": 0.8722333067943511,
            "status": "completed",
            "created_at": "2025-06-20T04:26:10.303758+00:00"
        },
        {
            "business_name": "Sunshine Motors LLC",
            "id": "c2296042-0fb5-435e-8bb7-420f67fc2579",
            "risk_score": 1.450489360319999,
            "status": "completed",
            "created_at": "2025-06-20T04:26:26.181357+00:00"
        }
    ]
}

export const mock_associated_people = [
    {
        id: "person_1",
        name: "Callie Tyler",
        role: "Registered agent",
        type: "agent",
        email: "callie.tyler@legalservices.com",
        phone: "(555) 123-4567",
        address: "321 Legal Plaza, Law City, LC 33445",
        linkedIn: null,
        riskLevel: "medium", // This will show "Address is residential" warning
        backgroundCheck: "completed", // This will show "Address is active" check
        ownershipPercentage: 0,
        dateJoined: "2017-11-05",
        responsibilities: ["Legal Document Receipt", "Compliance Notifications", "State Filings"],
        education: "BA Business Administration"
    },
    {
        id: "person_2",
        name: "Sarah Johnson",
        role: "Chief Executive Officer",
        type: "executive",
        email: "sarah.johnson@company.com",
        phone: "(555) 234-5678",
        address: "123 Executive Lane, Business City, BC 12345",
        linkedIn: "https://linkedin.com/in/sarahjohnson",
        riskLevel: "low", // This will show "Yes" for citedOnWebsite
        backgroundCheck: "completed",
        ownershipPercentage: 45, // This will show as references and trigger otherLinkedEntities > 20
        dateJoined: "2018-03-15",
        responsibilities: ["Strategic Planning", "Board Relations", "Public Relations"],
        education: "MBA from Stanford University"
    },
    {
        id: "person_3",
        name: "David Thompson",
        role: "Registered agent",
        type: "agent",
        email: "david.thompson@legalservices.com",
        phone: "(555) 345-6789",
        address: "789 Legal Avenue, Agent City, AC 55667",
        linkedIn: null,
        riskLevel: "low", // This will show no "Address is residential" warning
        backgroundCheck: "completed", // This will show "Address is active" check
        ownershipPercentage: 0,
        dateJoined: "2019-05-20",
        responsibilities: ["Document Management", "State Compliance", "Legal Notifications"],
        education: "JD from Yale Law School"
    },
    {
        id: "person_4",
        name: "Michael Chen",
        role: "Chief Technology Officer",
        type: "executive",
        email: "michael.chen@company.com",
        phone: "(555) 456-7890",
        address: "456 Tech Boulevard, Innovation City, IC 67890",
        linkedIn: "https://linkedin.com/in/michaelchen",
        riskLevel: "medium", // This will show "No" for citedOnWebsite
        backgroundCheck: "pending",
        ownershipPercentage: 25, // This will show as references and trigger otherLinkedEntities > 20
        dateJoined: "2016-07-22",
        responsibilities: ["Technology Strategy", "Product Development"],
        education: "MS Computer Science from MIT"
    },
    {
        id: "person_5",
        name: "Emily Rodriguez",
        role: "Board Member",
        type: "board_member",
        email: "emily.rodriguez@boardadvisors.com",
        phone: "(555) 345-6789",
        address: "789 Governance Street, Corporate City, CC 11223",
        linkedIn: "https://linkedin.com/in/emilyrodriguez",
        riskLevel: "low",
        backgroundCheck: "completed",
        ownershipPercentage: 15,
        dateJoined: "2020-01-10",
        responsibilities: ["Risk Oversight", "Audit Committee", "Compensation Committee"],
        education: "JD from Harvard Law School"
    },
    {
        id: "person_6",
        name: "Jessica Martinez",
        role: "Chief Financial Officer",
        type: "executive",
        email: "jessica.martinez@company.com",
        phone: "(555) 567-8901",
        address: "321 Finance Street, Money City, MC 88990",
        linkedIn: "https://linkedin.com/in/jessicamartinez",
        riskLevel: "low", // This will show "Yes" for citedOnWebsite
        backgroundCheck: "completed",
        ownershipPercentage: 20, // This will show as references but not trigger otherLinkedEntities > 20
        dateJoined: "2019-02-14",
        responsibilities: ["Financial Planning", "Risk Management"],
        education: "MBA Finance from Wharton"
    },
    {
        id: "person_7",
        name: "Alex Wilson",
        role: "Registered agent",
        type: "agent",
        email: "alex.wilson@agents.com",
        phone: "(555) 678-9012",
        address: "654 Service Road, Legal Town, LT 77889",
        linkedIn: null,
        riskLevel: "medium", // This will show "Address is residential" warning
        backgroundCheck: "pending", // This will not show "Address is active" check
        ownershipPercentage: 0,
        dateJoined: "2021-08-10",
        responsibilities: ["Legal Services", "Compliance", "Documentation"],
        education: "Paralegal Certificate"
    },
    {
        id: "person_4",
        name: "David Thompson",
        role: "Registered Agent",
        type: "agent",
        email: "david.thompson@legalservices.com",
        phone: "(555) 456-7890",
        address: "321 Legal Plaza, Law City, LC 33445",
        linkedIn: null,
        riskLevel: "low",
        backgroundCheck: "completed",
        ownershipPercentage: 0,
        dateJoined: "2017-11-05",
        responsibilities: ["Legal Document Receipt", "Compliance Notifications", "State Filings"],
        education: "BA Business Administration"
    }
];

export const mock_detailed = {
    "verification_request_id": "92fcd1ffecd94b5d876f25d08b60cf95",
    "request": {
        "match_type": "EXACT",
        "searched_urls": [],
        "created_at": "2025-06-16T15:01:45.735259+00:00",
        "score": 0.8223655856577509,
        "profile_completeness": 0.647887323943662,
        "sources_scanned": 246,
        "business_name": "Have to Clean Inc",
        "address": "600 S Green Ave, Glendale, CA, 91205, US"
    },
    "risk_summary": [
        {
            "score_type": "TRIVIAL",
            "risk_level": "HIGH",
            "score": 0.8223655856577509,
            "top_pos_assessments": [
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "WebsiteAboutUsCheck",
                    "ui_string": "Entity website does not contain expected references in its 'About' page",
                    "score": 1.3,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "WebsiteNoBrokenLinks",
                    "ui_string": "None",
                    "score": 1.2,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "Address would be deliverable with changes",
                    "score": 1.1,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "EmailFillerFakeDisposableRisk",
                    "ui_string": "Email address may be auto-generated or fake",
                    "score": 1.1,
                    "node_ids": [],
                    "result_sign": "Positive"
                },
                {
                    "name": "UbosFound",
                    "ui_string": "Business owner - single owner found",
                    "score": 1.1,
                    "node_ids": [
                        "8a45cbd5-de9d-4416-856a-7b7a6b5f8297"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "WebsiteNoTypos",
                    "ui_string": "None",
                    "score": 1.1,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Positive"
                }
            ],
            "top_neg_assessments": [
                {
                    "name": "EntitySocialMediaPresence",
                    "ui_string": "Entity operating activity - Facebook page was found for this business",
                    "score": 0.85,
                    "node_ids": [
                        "ad16759c-d118-498d-8d23-2d01888bae62"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "EntitySocialMediaPresence",
                    "ui_string": "Entity operating activity - LinkedIn page was found for this business",
                    "score": 0.85,
                    "node_ids": [
                        "ad16759c-d118-498d-8d23-2d01888bae62"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "WebsiteHasContactInfo",
                    "ui_string": "Entity website makes references to the contact email and phone number for the business",
                    "score": 0.9,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "EmailIsPrivateRelay",
                    "ui_string": "None",
                    "score": 0.95,
                    "node_ids": [],
                    "result_sign": "Negative"
                },
                {
                    "name": "EntityWatchlistsCheck",
                    "ui_string": "Watchlists - no hits detected for business nor owners",
                    "score": 0.95,
                    "node_ids": [
                        "ad16759c-d118-498d-8d23-2d01888bae62"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "None",
                    "score": 0.97,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "None",
                    "score": 0.97,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "None",
                    "score": 0.97,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                }
            ]
        },
        {
            "score_type": "KYB",
            "risk_level": "LOW",
            "score": 0.18215315753164263,
            "top_pos_assessments": [
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "Address would be deliverable with changes",
                    "score": 1.1,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "UbosFound",
                    "ui_string": "Business owner - single owner found",
                    "score": 1.1,
                    "node_ids": [
                        "8a45cbd5-de9d-4416-856a-7b7a6b5f8297"
                    ],
                    "result_sign": "Positive"
                }
            ],
            "top_neg_assessments": [
                {
                    "name": "EntityWatchlistsCheck",
                    "ui_string": "Watchlists - no hits detected for business nor owners",
                    "score": 0.95,
                    "node_ids": [
                        "ad16759c-d118-498d-8d23-2d01888bae62"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "None",
                    "score": 0.97,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "None",
                    "score": 0.97,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsDeliverable",
                    "ui_string": "None",
                    "score": 0.97,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsValid",
                    "ui_string": "Address - listed address is valid address",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsValid",
                    "ui_string": "Address - listed address is valid address",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                }
            ]
        },
        {
            "score_type": "FIRST_PARTY",
            "risk_level": "HIGH",
            "score": 0.6440242149300955,
            "top_pos_assessments": [
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "AddressIsResidential",
                    "ui_string": "Address - listed address is residential",
                    "score": 1.3,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "UbosFound",
                    "ui_string": "Business owner - single owner found",
                    "score": 1.1,
                    "node_ids": [
                        "8a45cbd5-de9d-4416-856a-7b7a6b5f8297"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "WebsiteReferencesAddress",
                    "ui_string": "Entity website does not contain expected references to the business address",
                    "score": 1.1,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "WebsiteReferencesOwners",
                    "ui_string": "Entity website does not contain expected references to business owners",
                    "score": 1.1,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Positive"
                }
            ],
            "top_neg_assessments": [
                {
                    "name": "WebsiteHasContactInfo",
                    "ui_string": "Entity website makes references to the contact email and phone number for the business",
                    "score": 0.9,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsPOBox",
                    "ui_string": "Address - listed address is not a P.O. box",
                    "score": 0.98,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "EntityExistsAndValid",
                    "ui_string": "Entity registration is valid and in good standing",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "ad16759c-d118-498d-8d23-2d01888bae62"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsActive",
                    "ui_string": "None",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsActive",
                    "ui_string": "None",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsActive",
                    "ui_string": "None",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "AddressIsActive",
                    "ui_string": "None",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "e2461540-52c2-4a2b-ad67-2b7735323030"
                    ],
                    "result_sign": "Negative"
                }
            ]
        },
        {
            "score_type": "SYNTHETIC",
            "risk_level": "LOW",
            "score": 0.2298999999999999,
            "top_pos_assessments": [
                {
                    "name": "EmailFillerFakeDisposableRisk",
                    "ui_string": "Email address may be auto-generated or fake",
                    "score": 1.1,
                    "node_ids": [],
                    "result_sign": "Positive"
                },
                {
                    "name": "WebsiteNoTypos",
                    "ui_string": "None",
                    "score": 1.1,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Positive"
                },
                {
                    "name": "EmailContainsRoleAlias",
                    "ui_string": "Email contains a role alias",
                    "score": 1.0000000000000002,
                    "node_ids": [],
                    "result_sign": "Positive"
                },
                {
                    "name": "WebsiteFillerFakeDisposableRisk",
                    "ui_string": "None",
                    "score": 1.0000000000000002,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Positive"
                }
            ],
            "top_neg_assessments": [
                {
                    "name": "EmailIsPrivateRelay",
                    "ui_string": "None",
                    "score": 0.95,
                    "node_ids": [],
                    "result_sign": "Negative"
                },
                {
                    "name": "EmailTumbleRisk",
                    "ui_string": "None",
                    "score": 0.98,
                    "node_ids": [],
                    "result_sign": "Negative"
                },
                {
                    "name": "EntityExistsAndValid",
                    "ui_string": "Entity registration is valid and in good standing",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "ad16759c-d118-498d-8d23-2d01888bae62"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "DomainIsNotTumbled",
                    "ui_string": "None",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "WebsiteExistsAndValid",
                    "ui_string": "Entity website was found for the business and is valid",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Negative"
                },
                {
                    "name": "WebsiteTldRisk",
                    "ui_string": "None",
                    "score": 0.9999999999999999,
                    "node_ids": [
                        "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                    ],
                    "result_sign": "Negative"
                }
            ]
        }
    ],
    "entity": {
        "business_entity_id": "ad16759c-d118-498d-8d23-2d01888bae62",
        "legal_name": "HAVE TO CLEAN INC",
        "dba_names": [],
        "state_code": "CA",
        "status": "Active",
        "is_valid_status": true,
        "state_id": "5727910",
        "incorporation_date": "2023-05-13T00:00:00",
        "registered_agent": {
            "name": "HASMIK ARYA",
            "address": "600 South Green Avenue #6, Glendale, CA 91205-2339, USA"
        },
        "ein": null,
        "oc_url": "https://opencorporates.com/companies/us_ca/5717010"
    },
    "ubos": [
        {
            "name": "Hasmik Arya",
            "role": "Chief Executive Officer",
            "online_references_count": 3,
            "cited_on_website": false,
            "affiliated_addresses": [
                "600 S GLENDALE AVE, APT 6, GLENDALE, CA, 91205, United States"
            ],
            "sources": [
                "sos",
                "https://www.bizapedia.com/ca/have-to-clean-inc.html",
                "https://www.buzzfile.com/business/have-to-clean-inc-747-333-9671"
            ],
            "linkedin": null,
            "associated_entities": [],
            "node_id": "8a45cbd5-de9d-4416-856a-7b7a6b5f8297"
        }
    ],
    "liens": {
        "open": [],
        "closed": []
    },
    "litigations": {
        "open": [],
        "closed": []
    },
    "graph_data": {
        "nodes": [
            {
                "id": "ad16759c-d118-498d-8d23-2d01888bae62",
                "label": "HAVE TO CLEAN INC",
                "type": "COMPANY",
                "data": {
                    "state_code": "CA",
                    "state_id": "5717010",
                    "status": "Active",
                    "is_valid_status": true,
                    "incorporation_date": "2023-05-13T00:00:00"
                }
            },
            {
                "id": "addr_19c29e37-d826-45e2-9f55-bf90f3aa9ec9",
                "label": "600 South Green Avenue #6, Glendale, CA 91205-2339, USA",
                "type": "ADDRESS",
                "data": {
                    "confidence": 100,
                    "type": "OFFICE_ADDRESS"
                }
            },
            {
                "id": "person_8a45cbd5-de9d-4416-856a-7b7a6b5f8297",
                "label": "Hasmik Arya",
                "type": "PERSON",
                "data": {
                    "first_name": "Hasmik",
                    "last_name": "Arya",
                    "linkedin": null,
                    "role": "Chief Executive Officer"
                }
            }
        ],
        "edges": [
            {
                "label": "Office",
                "type": "has_address",
                "source": "ad16759c-d118-498d-8d23-2d01888bae62",
                "target": "addr_19c29e37-d826-45e2-9f55-bf90f3aa9ec9",
                "confidence": 95
            },
            {
                "label": "Mail",
                "type": "has_address",
                "source": "ad16759c-d118-498d-8d23-2d01888bae62",
                "target": "addr_19c29e37-d826-45e2-9f55-bf90f3aa9ec9",
                "confidence": 85
            },
            {
                "label": "Agent",
                "type": "has_address",
                "source": "ad16759c-d118-498d-8d23-2d01888bae62",
                "target": "addr_19c29e37-d826-45e2-9f55-bf90f3aa9ec9",
                "confidence": 90
            },
            {
                "label": "Chief Executive Officer",
                "type": "associated_with",
                "source": "person_8a45cbd5-de9d-4416-856a-7b7a6b5f8297",
                "target": "ad16759c-d118-498d-8d23-2d01888bae62",
                "confidence": 60
            }
        ]
    },
    "company_details": {
        "addresses": [
            {
                "id": "19c29e37-d826-45e2-9f55-bf90f3aa9ec9",
                "type": "ADDRESS",
                "association_type": [
                    "OFFICE_ADDRESS",
                    "MAILING_ADDRESS",
                    "REGISTERED_AGENT_ADDRESS"
                ],
                "source": [
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.720089"
                    },
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.720120"
                    },
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.720126"
                    }
                ],
                "value": "600 South Green Avenue #6, Glendale, CA 91205-2339, USA",
                "confidence": 100,
                "assessments": [],
                "data": null
            }
        ],
        "web_presence": [
            {
                "id": "38b2780e-5d2a-46e2-8951-db9d9fa04385",
                "type": "DOMAIN",
                "association_type": [
                    "OWNS"
                ],
                "source": [
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.833086"
                    },
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.833140"
                    }
                ],
                "value": "https://havetocleaninc.com",
                "confidence": 100,
                "assessments": [
                    {
                        "name": "WebsiteAboutUsCheck",
                        "ui_string": "Entity website does not contain expected references in its 'About' page",
                        "score": 1.3,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteNoBrokenLinks",
                        "ui_string": "None",
                        "score": 1.2,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteNoTypos",
                        "ui_string": "None",
                        "score": 1.1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteReferencesAddress",
                        "ui_string": "Entity website does not contain expected references to the business address",
                        "score": 1.1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteReferencesContactInfo",
                        "ui_string": "Entity website does not contain expected references to the business contact information",
                        "score": 1.1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteReferencesOwners",
                        "ui_string": "Entity website does not contain expected references to business owners",
                        "score": 1.1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteNoRedirects",
                        "ui_string": "None",
                        "score": 1.01,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteFillerFakeDisposableRisk",
                        "ui_string": "None",
                        "score": 1.0000000000000002,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteHasContactInfo",
                        "ui_string": "Entity website makes references to the contact email and phone number for the business",
                        "score": 0.9,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteLegalInPlace",
                        "ui_string": "None",
                        "score": 0.98,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "DomainIsNotTumbled",
                        "ui_string": "None",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteExistsAndValid",
                        "ui_string": "Entity website was found for the business and is valid",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteTldRisk",
                        "ui_string": "None",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "DomainNotCyrillic",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "DomainRegistrationRisk",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "DomainStatusRisk",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "WebsiteGenericLanguageCheck",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "WebsiteTldRisk",
                        "ui_string": "Website uses a standard length top-level domain",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "WebsiteExistsAndValid",
                        "ui_string": "Entity website was found for the business and is valid",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteReferencesAddress",
                        "ui_string": "Entity website does not contain expected references to the business address",
                        "score": 1.1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteReferencesOwners",
                        "ui_string": "Entity website does not contain expected references to business owners",
                        "score": 1.1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteHasContactInfo",
                        "ui_string": "Entity website makes references to the contact email and phone number for the business",
                        "score": 0.9,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteExistsAndValid",
                        "ui_string": "Entity website was found for the business and is valid",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteNoTypos",
                        "ui_string": "None",
                        "score": 1.1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "WebsiteFillerFakeDisposableRisk",
                        "ui_string": "None",
                        "score": 1.0000000000000002,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Positive"
                    },
                    {
                        "name": "DomainIsNotTumbled",
                        "ui_string": "None",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteExistsAndValid",
                        "ui_string": "Entity website was found for the business and is valid",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "WebsiteTldRisk",
                        "ui_string": "None",
                        "score": 0.9999999999999999,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Negative"
                    },
                    {
                        "name": "DomainNotCyrillic",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "DomainRegistrationRisk",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "DomainStatusRisk",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "WebsiteGenericLanguageCheck",
                        "ui_string": "None",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    },
                    {
                        "name": "WebsiteTldRisk",
                        "ui_string": "Website uses a standard length top-level domain",
                        "score": 1,
                        "node_ids": [
                            "38b2780e-5d2a-46e2-8951-db9d9fa04385"
                        ],
                        "result_sign": "Neutral"
                    }
                ],
                "data": null
            },
            {
                "id": "9eff77a8-3c5c-4049-b5a4-537d0b1bb72b",
                "type": "FACEBOOK",
                "association_type": [
                    "OWNS"
                ],
                "source": [
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.934269"
                    },
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.934314"
                    },
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:12.934344"
                    }
                ],
                "value": "https://www.facebook.com/have-to-clean-inc",
                "confidence": 100,
                "assessments": [],
                "data": null
            },
            {
                "id": "cbcb9fc3-adcb-4a28-a26f-3b0c0e93da4b",
                "type": "LINKEDIN",
                "association_type": [
                    "OWNS"
                ],
                "source": [
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:13.034548"
                    },
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:13.034587"
                    }
                ],
                "value": "https://www.linkedin.com/company/have-to-clean-inc",
                "confidence": 100,
                "assessments": [],
                "data": {
                    "employees": [],
                    "next_page": null
                }
            }
        ],
        "emails": [
            {
                "id": "1d9edef4-e5ca-491c-aefc-065c3b633e6d",
                "type": "EMAIL",
                "association_type": [
                    "OWNS"
                ],
                "source": [
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:13.134977"
                    }
                ],
                "value": "info@havetocleaninc.com",
                "confidence": 100,
                "assessments": [],
                "data": null
            }
        ],
        "phones": [
            {
                "id": "3cdbbfca-8812-41e2-b279-77868bc195b5",
                "type": "PHONE",
                "association_type": [
                    "OWNS"
                ],
                "source": [
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:13.237377"
                    },
                    {
                        "source_url": "sos_url",
                        "fetched_at": "2025-06-20T03:51:13.237408"
                    }
                ],
                "value": "+17473339671",
                "confidence": 100,
                "assessments": [],
                "data": null
            }
        ]
    }
}

// Function to get detailed mock data based on business ID
export const getMockDetailedData = (businessId) => {
    // Create variations of the base mock_detailed data for each business
    const businessVariations = {
        "92f26f4f-28b8-4e09-823a-280793c02c8e": { // Have to Clean Inc
            ...mock_detailed,
            request: {
                ...mock_detailed.request,
                business_name: "Have to Clean Inc"
            }
        },
        "9615d3e8-90a8-49af-a8e6-9acea632574b": { // Meowden Co
            ...mock_detailed,
            request: {
                ...mock_detailed.request,
                business_name: "Meowden Co",
                address: "456 Pet Street, Austin, TX 78701, US"
            }
        },
        "a1072499-c352-45f8-a3e7-206284128dbb": { // Renew Restore LLC
            ...mock_detailed,
            request: {
                ...mock_detailed.request,
                business_name: "Renew Restore LLC",
                address: "789 Renovation Ave, Denver, CO 80202, US"
            }
        },
        "c2296042-0fb5-435e-8bb7-420f67fc2579": { // Sunshine Motors LLC
            ...mock_detailed,
            request: {
                ...mock_detailed.request,
                business_name: "Sunshine Motors LLC",
                address: "321 Auto Plaza, Phoenix, AZ 85001, US"
            }
        }
    };

    // Return specific business data or default to the first one
    return businessVariations[businessId] || businessVariations["92f26f4f-28b8-4e09-823a-280793c02c8e"];
};

